import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import type { ISpinnerProps } from './ISpinnerProps';

export const spinnerStyles = cva(
  'inline-block w-4 h-4 animate-spin rounded-full border-2 border-solid !border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]',
  {
    variants: {
      intent: {
        primary: 'border-primary-500',
        secondary: 'border-white',
        tertiary: 'border-gray-200',
      },
      size: {
        sm: 'h-4 w-4 border-2',
        md: 'h-8 w-8 border-[3px]',
        lg: 'h-12 w-12 border-4',
      },
      defaultVariants: {
        intent: 'primary',
        size: 'sm',
      },
    },
  }
);

const Spinner = ({ className, intent, size, ...rest }: ISpinnerProps) => {
  return (
    <div className="flex h-5 w-5 items-center justify-center" {...rest}>
      <div
        className={twMerge(spinnerStyles({ intent, size }), className)}
        role="status"
      />
    </div>
  );
};

export default Spinner;
